import { lazy } from 'react';

export const PlayerBirthDateForm = lazy(() => import('./PlayerBirthDateForm'));
